module.exports = __webpack_public_path__ + "static/media/sl.9dcbe3a2.jpeg";